import useSWR from "swr";
import * as http from "@/utils/request";
import { RFResponse, RFResponseCommon } from "@/interfaces/common";
import { PromotionType, DepositRewards } from "@/interfaces/depoistReward";

const BASE_URL = process.env.NEXT_PUBLIC_BASE_API;

export const useDepositRewards = (promotionType: PromotionType) => {
	const url = `${BASE_URL}/promotion/api/rewards/deposit?promotionType=${promotionType}`;
	return useSWR(url, async (url) => {
		const { data } = await http.get<RFResponse<DepositRewards>>(url);
		return data;
	});
};

// >>>>>>>>>>>

export const claimAward = async (awardRecordId: number) => {
	const url = `${BASE_URL}/promotion/api/rewards/deposit/get`;

	try {
		const { code, data, message } = await http.post<{ awardRecordId: number }, RFResponseCommon<number>>(url, {
			awardRecordId,
		});

		if (code !== 200) throw Error(message);
		return true;
	} catch (error) {
		throw error;
	}
};
